import { render, staticRenderFns } from "./ManualIcon.vue?vue&type=template&id=48b5b3d6&scoped=true&"
import script from "./ManualIcon.vue?vue&type=script&lang=js&"
export * from "./ManualIcon.vue?vue&type=script&lang=js&"
import style0 from "./ManualIcon.vue?vue&type=style&index=0&id=48b5b3d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5b3d6",
  null
  
)

export default component.exports